import styles from "../products/analytics-table.module.css"

export default function VipPurchases({ data }) {
  return (
    <div className={styles.tableContainer}>
      <h2>VIP Purchases</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>VIP Type</th>
              <th>Purchase Count</th>
              <th>Total Revenue</th>
              <th>Unique User Count</th>
              <th>Avg Purchase Value</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item._id}</td>
                <td>{item.purchaseCount}</td>
                <td>{item.totalRevenue}</td>
                <td>{item.uniqueUserCount}</td>
                <td>{item.avgPurchaseValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
